import { render, staticRenderFns } from "./CardAdminSubCoordinadores.vue?vue&type=template&id=eaeac4c4&scoped=true"
import script from "./CardAdminSubCoordinadores.vue?vue&type=script&lang=js"
export * from "./CardAdminSubCoordinadores.vue?vue&type=script&lang=js"
import style0 from "./CardAdminSubCoordinadores.vue?vue&type=style&index=0&id=eaeac4c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaeac4c4",
  null
  
)

export default component.exports